import { render, staticRenderFns } from "./RedirectToAppstore.vue?vue&type=template&id=703972fc&scoped=true&"
import script from "./RedirectToAppstore.vue?vue&type=script&lang=js&"
export * from "./RedirectToAppstore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703972fc",
  null
  
)

export default component.exports